// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

require('moment')
require('jquery')

import $ from "jquery";
global.$ = jQuery;

require('admin-lte')

import 'bootstrap'
import '../stylesheets/application'
import '../stylesheets/loading'
import '../stylesheets/manuals'

import "admin-lte/plugins/fontawesome-free/css/all"
import "admin-lte/dist/css/adminlte.min.css"

require("packs/common.js")
require("packs/summernote.js")
require("packs/loading.js")
